import moment from 'moment';
import AdminService from 'external-services/diary-admin-service/admin.service';
import { MAX_CHAIRS, MAX_CHAIRS_LEGACY } from "floorplan-v2/app/appRoot/constants";
import PouchLoadService from "external-services/pouch-load-service/index";

const NS = 'PlanTableService';

export default function PlanTableService(
  SnapConst, SnapService, PlanConst, Group, Booking, $rootScope, tableLabelService, tableHelpersService
) {
  "ngInject";

  const THS = tableHelpersService;

  function Table(s, model, mode, blockouts, service, nextService, time, layout) {
    var defaults = {
      _id: PouchLoadService.getNewId(['table']),
      online: true,
      shared: false,
      capacity: 2,
      minCapacity: 1,
      rotation: 0,
      //type: - Forced to 'table' after extend of model, safe override
      //order - Added on table plan based on existing list of tables
      //sectionId - Added on table plan based on editing section
    };

    this.s = s;
    this.mode = mode;
    this.model = _.extend({}, defaults, model);
    this.model.chairs = THS.validateChairs(this.model);
    this.model.type = THS.Type;
    this.blockouts = blockouts;
    this.service = service;
    this.nextService = nextService;
    this.layout = layout;
    this.bookings = {
      alls: []
    };
    this.visibleBookings = [];
    this.listeners = [];
    this.labelLines = [];
    this.model.shape = THS.getShape(this.model.shape);
    //Delete wrong table position
    this.model.position = THS.verifyPosition(this.model);
    this.venue = AdminService.getVenue()
    //Amend wrong chairs definition
    var hasChairs = _.size(_.filter(this.model.chairs, function (val) {
      return val != null;
    })) > 0;
    if (!hasChairs) {
      delete this.model.chairs;
    }
    //Render group for menu and  plan, hide them
    if (this.mode === PlanConst.Mode.Layout) {
      this.renderMenuTable();
      SnapService.show(this.getMenuTable(), false);
    }
    this.renderPlanTable(time);
    SnapService.show(this.getPlanTable(), false);

    var _self = this;
    var destroy = $rootScope.$on('plan-destroy', function () {
      // Remove all listeners
      _.each(_self.listeners, function (listener) {
        listener();
      });
      // Remove this same function
      destroy();
    });

    window.renderedTables.added++;
  }

  Table.prototype = {

    buildRootElement: function (useCapacity, renderBlockOutLayer) {
      var shape = THS.getSize(this.model, useCapacity);
      shape.type = THS.getShape(this.model.shape);
      var group = new Group(this.s, 'table ' + this.model.name, shape);
      group.getSGroup().addClass('table');
      var borderRadius = shape.type === SnapConst.Shapes.Circle ? shape.w : 0;
      group.addElement(this.s.rect(0, 0, shape.w, shape.h, borderRadius, borderRadius).addClass('root'), 'table');
      if (renderBlockOutLayer) {
        group.addElement(this.s.rect(0, 0, shape.w, shape.h, borderRadius, borderRadius).addClass('blockout'), 'blockout');
      }
      return group;
    },

    renderMenuTable: function () {
      this.menuTable = this.buildRootElement(false, false);
      this.menuTable.getSGroup().addClass('basic');
      this.buildLabel(this.menuTable);
    },

    renderPlanTable: function (time) {
      //Build table
      this.planTable = this.buildRootElement(true, this.mode === PlanConst.Mode.Bookings);
      var sGroup = this.planTable.getSGroup();
      sGroup.addClass('full');
      if (this.mode === PlanConst.Mode.Bookings) {
        sGroup.addClass('unknown');
      }
      sGroup.attr({
        'data-rot': 0
      });
      sGroup.attr({
        tableid: this.model._id
      });

      //Build chairs
      this.renderChairs();

      //Add label
      if (this.mode === PlanConst.Mode.Layout) {
        this.buildLabel(this.planTable, time);
      }

      //Add bookings details icon
      this.renderBookigDetailsIcon();

      //Create new booking
      if (this.mode === PlanConst.Mode.Bookings) {
        /**
         * Setting allowPassThrough to true fixes issue where pinch zoom wasn't working on floorplan
         * when the touch origin was over a table.
         */
        const allowPassThrough = true;
        this.listeners.push(SnapService.onClick(this.planTable, function (evt) {
          this.createBooking(evt);
        }, this, allowPassThrough));
      }
    },

    renderChairs: function () {
      //Build chairs
      var shape = THS.getSize(this.model, true);
      this.chairs = [];
      const cap = tableHelpersService.getCapacity(this.model.capacity);
      const notCircular = THS.getShape(this.model.shape) !== SnapConst.Shapes.Circle;
      if (notCircular) {
        //Square and rect table
        var chairsDistribution = THS.getChairsDistribution(this.model);
        var steps = [
          (shape.w - (THS.Sizes.Chair.w * Math.max(1, chairsDistribution[0]))) / (Math.max(1, chairsDistribution[0]) + 1), //top
          (shape.h - (THS.Sizes.Chair.w * Math.max(1, chairsDistribution[1]))) / (Math.max(1, chairsDistribution[1]) + 1), //right
          (shape.w - (THS.Sizes.Chair.w * Math.max(1, chairsDistribution[2]))) / (Math.max(1, chairsDistribution[2]) + 1), //bottom
          (shape.h - (THS.Sizes.Chair.w * Math.max(1, chairsDistribution[3]))) / (Math.max(1, chairsDistribution[3]) + 1), //left
        ];
        var fulls = [
          shape.w === (THS.Sizes.Body.w * Math.max(1, chairsDistribution[0])),
          shape.h === (THS.Sizes.Body.w * Math.max(1, chairsDistribution[1])),
          shape.w === (THS.Sizes.Body.w * Math.max(1, chairsDistribution[2])),
          shape.h === (THS.Sizes.Body.w * Math.max(1, chairsDistribution[3]))
        ];
        var basicStep = (THS.Sizes.Body.w - THS.Sizes.Chair.w) / 2;
        _.each(chairsDistribution, function (qt, posIdx) {
          _.times((qt + 1), function (cnt) {
            if (qt === 0 || cnt > 0) {
              var chair = null,
                x, y;
              switch (posIdx) {
                case 0: //top bottom
                case 2:
                  y = posIdx === 0 ? -(THS.Sizes.Chair.h / 2) : (shape.h) - (THS.Sizes.Chair.h / 2);
                  if (fulls[posIdx]) {
                    //Side has max chairs number, apply spaces width basicStep
                    x = basicStep + Math.max(0, (cnt - 1)) * (basicStep * 2 + THS.Sizes.Chair.w);
                  } else {
                    //Side has less chairs, apply space around distribution
                    x = Math.max(1, cnt) * steps[posIdx] + Math.max(0, (cnt - 1)) * THS.Sizes.Chair.w;
                  }
                  chair = this.s.rect(x, y, THS.Sizes.Chair.w, THS.Sizes.Chair.h, 4, 4);
                  chair.addClass(posIdx === 0 ? 'chair top ' + cnt : 'chair bottom ' + cnt);
                  break;
                default: //right left
                  x = posIdx === 3 ? -(THS.Sizes.Chair.h / 2) : shape.w - (THS.Sizes.Chair.h / 2);
                  if (fulls[posIdx]) {
                    //Side has max chairs number, apply spaces width basicStep
                    y = basicStep + Math.max(0, (cnt - 1)) * (basicStep * 2 + THS.Sizes.Chair.w);
                  } else {
                    //Side has less chairs, apply space around distribution
                    y = Math.max(1, cnt) * steps[posIdx] + Math.max(0, (cnt - 1)) * THS.Sizes.Chair.w;
                  }
                  chair = this.s.rect(x, y, THS.Sizes.Chair.h, THS.Sizes.Chair.w, 4, 4);
                  chair.addClass(posIdx === 1 ? 'chair right ' + cnt : 'chair left ' + cnt);
                  this.chairs.push(chair);
                  break;
              }
              if (qt === 0) {
                chair.addClass('ghost');
              }
              this.chairs.push(chair);
            }
          }, this);
        }, this);
      } else {
        var adjust = null;
        switch (shape.w) { //Chairs of small circle table looks wider
          case 80:
            adjust = 3;
            break;
          case 160:
            adjust = 1;
            break;
          default:
            adjust = 0;
            break;
        }
        //Circle tables
        _.times(cap, function (n) {
          var angle = 360 * (n / cap);
          var chair = this.s.rect(shape.w / 2 - THS.Sizes.Chair.w / 2, -THS.Sizes.Chair.h / 2 + adjust, THS.Sizes.Chair.w, THS.Sizes.Chair.h, 4, 4).addClass('chair');
          if (n === 0) {
            chair.addClass('top');
          }
          chair.attr("transform", "rotate(" + angle + ", " + (shape.w / 2) + ", " + (shape.w / 2) + ")");
          this.chairs.push(chair);
        }, this);
        //Ghost chairs (centered rotation purpose)
        _.times(4, function (n) {
          var angle = n * 90;
          var chair = this.s.rect(shape.w / 2 - THS.Sizes.Chair.w / 2, -THS.Sizes.Chair.h / 2, THS.Sizes.Chair.w, THS.Sizes.Chair.h, 4, 4).addClass('chair ghost');
          chair.attr("transform", "rotate(" + angle + ", " + shape.w / 2 + ", " + shape.w / 2 + ")");
          this.chairs.push(chair);
        }, this);
      }
      //Add chairs
      _.each(this.chairs, function (chair) {
        chair.insertBefore(this.planTable.getElement('table'));
      }, this);

      const maxChairs = this.venue.enableNewFloorPlan ? MAX_CHAIRS : MAX_CHAIRS_LEGACY
      if (this.model.capacity >= maxChairs) {
        const people = this.s.text(0, 0, `C${this.model.capacity}`).addClass(`capacity-text-${notCircular ? 'rect' : 'circ'} ${this.model.rotation ? `rot-${this.model.rotation}` : ''}`);
        this.planTable.addElement(people, 'capacityTextGroup');
      }
    },

    renderBookigDetailsIcon: function () {
      if (this.mode === PlanConst.Mode.Bookings) {
        var shape = THS.getSize(this.model, true);
        var moreSize = 12;
        this.more = new Group(this.s, 'more', {
          type: SnapConst.Shapes.Rect,
          w: moreSize,
          h: moreSize
        });
        var icon = this.s.image("images/view-list.svg", 0, 0, moreSize, moreSize);
        this.more.addElement(icon, 'icon');
        this.planTable.addElement(this.more, 'more');
        this.more.buildRootElement();
        if (THS.getShape(this.model.shape) === SnapConst.Shapes.Circle) {
          SnapService.place(this.more, shape.w / 2 - moreSize / 2, shape.h - moreSize);
        } else {
          SnapService.place(this.more, 0, shape.h - moreSize);
        }
        SnapService.show(this.more, false);
        //Register events for details
        this.listeners.push(SnapService.onClick(this.more, function (evt) {
          this.showBookingsDetails(this.bookings.availables, true, evt);
        }, this));
        //Register events for more mouseover
        var _self = this;
        var overMoreHandler = function (evt) {
          _self.showBookingsDetails(_self.bookings.availables, true, evt);
        };
        this.more.getSGroup().mouseover(overMoreHandler);
        this.listeners.push(function () {
          _self.more.getSGroup().unmouseover(overMoreHandler);
        });
      }
    },


    /**
     * Render the label when its content has been changed from the last render
     */
    buildLabel: function (target, time) {
      const labelLines = tableLabelService.buildLabel(target, time, this.mode, this.model, this.labelLines, this.s, this.service, this.nextService);
      if (labelLines) {
        this.labelLines = labelLines;
      }
    },


    buildContent: function () {
      var _self = this;
      //Detect presence of bookings and mark table as bookings holder
      var areBookingsOverTable = _.size(this.bookings.currents) > 0 || (_.size(this.bookings.nexts) > 0);
      this.getPlanTable().getSGroup().toggleClass('hasbookings', areBookingsOverTable);

      //Append and positioning of over table bookings
      if (!areBookingsOverTable) {
        // Cleanup previous visible bookings that are now missing
        _.each(this.visibleBookings, function (vb) {
          this.planTable.removeElement(vb.name);
        }, this);
        this.visibleBookings = [];
      } else {
        // Define tiles matrix based on bookings quantity and table measures
        var shape = SnapService.getShape(this.planTable); // need to be getShape
        var steps = {
          total: Math.max(1, _.size(this.bookings.currents)),
          size: Booking.Sizes.Body.w
        };
        if (!this.model.shared && steps.total > 1) {
          //Only shared table allow to show more then one booking at the same time
          steps.total = 1;
        }
        if (THS.getShape(this.model.shape) === SnapConst.Shapes.Circle) {
          steps.x = (shape.w - steps.size) / 2;
          steps.y = (shape.h - steps.size) / 2;
        } else {
          if (shape.w >= shape.h) {
            //Orizontal
            steps.c = THS.getSize(this.model, true).w / THS.Sizes.Body.w; //Math.max(chairs[0],chairs[2]);
            steps.r = Math.ceil(steps.total / steps.c);
            steps.x = (shape.w - steps.size * Math.min(steps.total, steps.c)) / (Math.min(steps.total, steps.c) + 1);
            steps.y = (shape.h - steps.size * steps.r) / (steps.r + 1);
          } else {
            //Vertical
            steps.r = THS.getSize(this.model, true).h / THS.Sizes.Body.h; //Math.max(chairs[1],chairs[3]);
            steps.c = Math.ceil(steps.total / steps.r);
            steps.x = (shape.w - steps.size * steps.c) / (steps.c + 1);
            steps.y = (shape.h - steps.size * Math.min(steps.total, steps.r)) / (Math.min(steps.total, steps.r) + 1);
          }
        }
        //Build contents blocks (currents if any, nexts else, or nothing otherwise)
        var newVisibleBookings = [];
        _.times(steps.total, function (idx) {
          var booking = null;
          if (_.size(this.bookings.currents) > 0) {
            booking = this.bookings.currents[idx];
          } else if (_.size(this.bookings.nexts) > 0) {
            booking = this.bookings.nexts[0];
          }
          if (booking != null) {
            newVisibleBookings.push(booking);
          }
        }, this);
        // Cleanup previous visible bookings that are now missing
        _.each(this.visibleBookings, function (vb) {
          var found = _.find(newVisibleBookings, function (nb) {
            return Booking.isSameBookingByTime(vb.booking, nb);
          });
          if (found == null) {
            this.planTable.removeElement(vb.name);
            vb.toRem = true;
          }
        }, this);
        this.visibleBookings = _.filter(this.visibleBookings, function (b) {
          return b.toRem !== true;
        });
        // Complete visibleBookings list with missing newVisibleBookings
        _.each(newVisibleBookings, function (nb) {
          var found = _.find(this.visibleBookings, function (vb) {
            return Booking.isSameBookingByTime(vb.booking, nb);
          });
          if (found == null) {
            var bookingWrap = {
              booking: nb,
              tile: nb.getTableBooking(_.size(this.bookings.nexts) - 1),
              listeners: [],
              appended: false
            };
            var element = bookingWrap.tile.getSGroup();
            this.visibleBookings.push(bookingWrap);
            // Mouse over booking tile
            var bookingMouseOverHandler = function (evt) {
              _self.showBookingsDetails([bookingWrap.booking], false, evt);
            };
            element.mouseover(bookingMouseOverHandler);
            bookingWrap.listeners.push(function () {
              element.unmouseover(bookingMouseOverHandler);
            });
            // Mouse out booking tile
            var bookingMouseOutHandler = function () {
              _self.hideBookingsDetails();
            };
            element.mouseout(bookingMouseOutHandler);
            bookingWrap.listeners.push(function () {
              element.unmouseout(bookingMouseOutHandler);
            });
            //Click on booking tile
            bookingWrap.listeners.push(SnapService.onClick(element, function (evt) {
              $rootScope.$broadcast('edit-booking', evt, bookingWrap.booking.model);
            }, this));
          } else {
            found.booking.refreshTableBooking();
          }
        }, this);

        //Append and place the content blocks
        _.each(this.visibleBookings, function (item, idx) {
          if (!item.appended) {
            item.appended = true;
            item.name = 'booking_' + item.booking.meta.id;
            this.planTable.addElement(item.tile, item.name);
            var crot = (this.model.rotation > 0 ? -this.model.rotation : Math.abs(this.model.rotation));
            SnapService.rotate(item.tile, crot);
          }
          var pos = this.getContentPosition(steps, idx);
          if (!(item.position && item.position.x === pos.x && item.position.y === pos.y)) {
            item.position = pos;
            SnapService.place(item.tile, item.position.x, item.position.y);
          }
        }, this);
      }

      // Verify visible bookings conditions
      var isMaterTable = false; //Flag the table when only one booking is visible and it is a Booking.JoinedStatuses.Master
      var isSlaveTable = false; //Flag the table when only one booking is visible and it is a Booking.JoinedStatuses.Slave
      if (this.visibleBookings.length === 1) {
        isMaterTable = this.visibleBookings[0].booking.meta.joinedType === Booking.JoinedStatuses.Master;
        isSlaveTable = this.visibleBookings[0].booking.meta.joinedType === Booking.JoinedStatuses.Slave;
      }
      this.planTable.getSGroup().toggleClass('master', isMaterTable);
      this.planTable.getSGroup().toggleClass('slave', isSlaveTable);
    },

    getContentPosition: function (steps, index) {
      //Compute block position
      var pos = {};
      var shape = SnapService.getShape(this.planTable);
      switch (THS.getShape(this.model.shape)) {
        case SnapConst.Shapes.Circle:
          if (steps.total === 1) {
            //centered
            pos.x = steps.x;
            pos.y = steps.y;
          } else {
            var angle = 360 / steps.total * index;
            pos.x = Math.sin(angle * Math.PI / 180) * (shape.w - 80) / 2 + shape.w / 2 - 28;
            pos.y = Math.cos(angle * Math.PI / 180) * (shape.h - 80) / 2 + shape.h / 2 - 28;
          }
          break;
        default:
          if (shape.w >= shape.h) {
            //Orizontal
            pos.x = ((index % steps.c) * steps.size) + ((index % steps.c) + 1) * steps.x;
            pos.y = (Math.floor(index / steps.c) * steps.size) + (steps.y * (Math.floor(index / steps.c) + 1));
          } else {
            //Vertical
            pos.x = (Math.floor(index / steps.r) * steps.size) + (steps.x * (Math.floor(index / steps.r) + 1));
            pos.y = ((index % steps.r) * steps.size) + ((index % steps.r) + 1) * steps.y;
          }
          break;
      }
      return pos;
    },

    showBookingsDetails: function (bookings, showOver, evt) {
      this.hideBookingsDetails();
      $rootScope.$broadcast('place-bookings-detail', evt, this, bookings, showOver);
    },

    hideBookingsDetails: function () {
      $rootScope.$broadcast('remove-bookings-detail');
    },

    rotate: function (angle) {
      //Rotate table
      SnapService.rotate(this.getPlanTable(), angle);
      this.getPlanTable().getSGroup().attr({
        'data-rot': this.model.rotation
      });
      this.model.rotation = SnapService.getRotation(this.getPlanTable());
      //Counter rotate tiles
      var crot = (angle > 0 ? -angle : Math.abs(angle));
      _.each(this.visibleBookings, function (item) {
        SnapService.rotate(item.tile, crot);
      }, this);
      //Counter rotate label
      if (this.planTable.getElement('label')) {
        SnapService.rotate(this.planTable.getElement('label'), crot);
      }
      //Counter rotate more bookings icon
      if (this.more) {
        SnapService.rotate(this.more, crot);
        var size = 12;
        switch (this.model.rotation) {
          case 315:
          case -45:
          case 0:
            SnapService.place(this.more, 0, this.planTable.shape.h - size);
            break;
          case 45:
          case 90:
            SnapService.place(this.more, this.planTable.shape.w - size, this.planTable.shape.h - size);
            break;
          case 135:
          case 180:
            SnapService.place(this.more, this.planTable.shape.w - size, 0);
            break;
          case 225:
          case 270:
          case -90:
            SnapService.place(this.more, 0, 0);
            break;
        }
      }
    },

    refresh: function (time) {
      switch (this.mode) {
        case PlanConst.Mode.Bookings:
          //Apply table blockout status based on specific time
          var hasBlockout = _.find(this.blockouts, function (blockout) {
            return time.isBetween(blockout.start, blockout.end);
          }) != null;
          var sGroup = this.getPlanTable().getSGroup();
          sGroup.toggleClass('blockout', hasBlockout);
          break;
        default:
          console.warn('THS.refresh not supported in mode', this.mode);
          break;
      }
    },

    createBooking: function (evt) {
      if (this.mode === PlanConst.Mode.Bookings && (
        this.status === THS.Statuses.Free ||
        this.status === THS.Statuses.Next ||
        this.model.shared)) {
        $rootScope.$broadcast('create-booking', evt, this);
      }
    },

    //Lookup for tableJoins override capacity
    getBookingOverrideCapacity: function (booking) {
      var overrideCapacity = null;
      if (this.layout.tablesJoins) {
        _.each(this.layout.tablesJoins, function (join) {
          if (booking.people >= join.minCapacity && booking.people <= join.capacity) {
            var matchingTables = true;
            _.each(_.pluck(booking.tables, '_id'), function (id) {
              matchingTables &= _.contains(join.tables, id); // jshint ignore:line
            }, this);
            overrideCapacity = matchingTables ? join.capacity : null;
          }
        }, this);
      }

      return overrideCapacity;
    },

    updateServices: function (service, nextService) {
      this.service = service;
      this.nextService = nextService;
    },

    setBookings: function (bookings, time, overdueMinutes, conflictsMinutes, companyNameFirst) {
      //Bookings are available only in Mode.Bookings
      var timeCost = {
        buildContent: 0,
        other: 0
      };
      if (this.mode === PlanConst.Mode.Bookings) {
        var start = performance.now();
        // Build nextBookings
        var defaultDuration = this.service.bookingDuration || PlanConst.Bookings.duration;

        var nextBookings = [];
        _.each(bookings, function (booking) {
          var overrideCapacity = this.getBookingOverrideCapacity(booking);
          nextBookings.push(new Booking(this.s, this.model, booking, time, defaultDuration, overdueMinutes, overrideCapacity, companyNameFirst));
        }, this);
        // Remove old missing, add new, update meta of matching and sort result list by time
        var toRem = _.filter(this.bookings.alls, function (b) {
          var match = _.find(nextBookings, function (nb) {
            return Booking.isSameBookingByTime(b, nb);
          });
          return match == null;
        });
        var toAdd = _.filter(nextBookings, function (nb) {
          var match = _.find(this.bookings.alls, function (b) {
            return Booking.isSameBookingByTime(nb, b);
          });
          return match == null;
        }, this);
        // remove
        _.each(toRem, function (rem) {
          this.removeBooking(rem);
        }, this);
        // update
        _.each(this.bookings.alls, function (b) {
          var newMeta = Booking.getMetadata(this.model, b.model, time, defaultDuration, overdueMinutes, this.getBookingOverrideCapacity(b.model));
          b.meta = newMeta;
        }, this);
        // add
        _.each(toAdd, function (b) {
          b.justAdded = true;
        });
        this.bookings.alls = this.bookings.alls.concat(toAdd);
        // sort
        this.bookings.alls = _.sortBy(this.bookings.alls, function (b) {
          return moment(b.model.time).valueOf();
        });
        this.bookings = {
          alls: this.bookings.alls,
          dones: [],
          currents: [],
          nexts: [],
          fars: [],
          availables: []
        };

        if (bookings && bookings.length !== this.bookings.alls.length) {
          console.error('Incremental booking logic error');
        }
        //Distribute on sub lists based on type
        _.each(this.bookings.alls, function (booking) {
          switch (booking.meta.type) {
            case Booking.Statuses.Done:
              this.bookings.dones.push(booking);
              break;
            case Booking.Statuses.Current:
              this.bookings.currents.push(booking);
              break;
            case Booking.Statuses.Next:
              this.bookings.nexts.push(booking);
              break;
            case Booking.Statuses.Far:
              this.bookings.fars.push(booking);
              break;
          }
        }, this);
        //Bookings meaningfull at the current time means not expired from now to end of shedule
        this.bookings.availables = this.bookings.currents.concat(this.bookings.nexts, this.bookings.fars);
        //Apply color to table based on his bookings status
        this.planTable.getSGroup().removeClass('unknown free next current overdue master slave upcoming-conflicts running-conflicts');
        if (_.size(this.bookings.currents) > 0) {
          if (this.bookings.currents[0].meta.isOverdue) {
            this.status = THS.Statuses.Overdue;
          } else {
            this.status = THS.Statuses.Current;
          }
        } else if (_.size(this.bookings.nexts) > 0) {
          this.status = THS.Statuses.Next;
        } else if (THS.isRunningPrivateFun(this.service, time)) {
          this.status = THS.Statuses.Current;
        } else if (THS.isApproachingPrivateFun(this.nextService, time)) {
          this.status = THS.Statuses.Next;
        } else {
          this.status = THS.Statuses.Free;
        }

        //Check bookings conflicts inside time range between now and now+conflictsMinutes
        var conflictsFrom = moment(time);
        var conflictsTo = moment(time);
        if (conflictsMinutes != null) {
          conflictsTo.add(conflictsMinutes, 'm');
        }
        if (!this.model.shared) {
          var statuses = Booking.checkConflicts(this.bookings.availables, conflictsFrom, conflictsTo);
          var runnings = _.filter(statuses, function (status) {
            return status.running;
          });
          var upcomings = _.filter(statuses, function (status) {
            return status.upcoming;
          });
          this.planTable.getSGroup().toggleClass('running-conflicts', runnings.length > 1);
          var chairsSet = this.getPlanTable().getSGroup().selectAll('.chair:not(.ghost)');
          if (upcomings.length > 1 || runnings.length > 1) {
            THS.animateChairsSet(chairsSet);
          } else {
            // Remove blinking animation
            _.each(chairsSet, function (chair) {
              chair.stop();
              chair.attr({
                opacity: 1
              });
            });
          }
        }
        //Apply status class to planTable
        this.planTable.getSGroup().addClass(this.status);
        //Show if there's bookings not done for the day
        SnapService.show(this.more, _.size(this.bookings.alls) > _.size(this.bookings.dones));
        timeCost.other = performance.now() - start;

        start = performance.now();
        //Re-render the label
        this.buildLabel(this.planTable, time);
        //Render the table content based on its bookings for the day
        this.buildContent();
        timeCost.buildContent = performance.now() - start;
      }
      return timeCost;
    },

    removeBooking: function (booking) {
      // _.each(this.bookings.alls, function (booking) { booking.destroy(); }, this);
      var idx = _.findIndex(this.bookings.alls, function (b) {
        return booking.meta.id === b.meta.id;
      });
      if (idx >= 0) {
        this.bookings.alls[idx].destroy();
        this.bookings.alls.splice(idx, 1);
      } else {
        console.warn('THS.removeBooking', booking, 'not found');
      }
    },

    getMenuTable: function () {
      return this.menuTable;
    },

    getPlanTable: function () {
      return this.planTable;
    }
  };

  return Table;
}
